import universal from 'react-universal-component';
import { LoadingComponent } from '../../components/LoadingComponent';
import React from 'react';

export default universal(() => import('./PlayerProjections'), {loading: <LoadingComponent />});



// WEBPACK FOOTER //
// ./src/app/views/PlayerProjections/index.js